import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { cspFormsService } from '../../services/cspforms.service';

import { English } from '../../core/languages';
import { SessionStorageService } from '../../core/index.service';
import { stringify } from '@angular/core/src/render3/util';

@Pipe({
    name: 'filter'
})
@Injectable()
export class FilterPipe implements PipeTransform {
    transform(items: any[], colValue: string, colName: string, retColName?: string): any {
        try {
            let ctrlText = items.filter(item => item[colName] === colValue);
            if (retColName !== null && retColName !== '' && retColName !== undefined) {
                return ctrlText[0][retColName];
            }
            else {
                return ctrlText[0];
            }
        }
        catch (e) {
            return "";
        }
    }

}

@Pipe({
    name: 'rowfilter'
})
@Injectable()
export class RowFilterPipe implements PipeTransform {
    transform(items: any[], colName: string, colValue: string): any {
        try {
            let ctrlText = items.filter(item => item[colName] === colValue);
            
            return ctrlText;
        }
        catch (e) { return items; }
    }

}

@Pipe({
    name: 'menuTypeFilter'
})
@Injectable()
export class MenuTypeFilter implements PipeTransform {
    transform(items: any[], colName1: string, colValue1: string,colName2:string): any {
        try {
            let ctrlText = items.filter(item => item[colName1] === colValue1 && item[colName2] == true);
            
            return ctrlText;
        }
        catch (e) { return items; }
    }

}

@Pipe({
    name: 'PdfFormfilter'
})
@Injectable()
export class PDFFormFilterPipe implements PipeTransform {
    transform(items: any[], colName1: string, colName2: string): any {
        try {
            let ctrlText = items.filter(item => item[colName1] === 3 && item[colName2] == true);
            for (var i = 0; i <= ctrlText.length; i++) {
                if (ctrlText != null && ctrlText.length > 0) {
                    if (ctrlText[i]["TxtAttach"].length > 0) {
                        return ctrlText;
                    }
                }
            }
        }
        catch (e) { return items; }
    }

}

@Pipe({
    name: 'Trim'
})
@Injectable()
export class TrimPipe implements PipeTransform {
    transform(items: any[]): any {
        try {
            let ctrlText = (items.toString().split('_')[1]).split('.')[0];
             //let ctrlText = (items.toString()).split('.')[0];
            return ctrlText;
        }
        catch (e) { return items; }
    }

}

@Pipe({
    name: 'reportFormfilter'
})
@Injectable()
export class ReportFormFilterPipe implements PipeTransform {
    transform(items: any[], colName1: string, colName2: string): any {
        try {
            let ctrlText = items.filter(item => item[colName1] === 4 && item[colName2] == true);
            for (var i = 0; i <= ctrlText.length; i++) {
                if (ctrlText != null && ctrlText.length > 0) {
                    if (ctrlText[i]["TxtAttach"].length > 0) {
                        return ctrlText;
                    }
                }
                
            }
        }
        catch (e) { return items; }
    }

}
@Pipe({
    name: 'permitfilter'
})
@Injectable()
export class PermitFilterPipe implements PipeTransform {    
    transform(items: any[], colName1: string, colName2: string): any {        
        try {
            let ctrlText = items.filter(item => item[colName1] === 6 && item[colName2] == true);
            for (var i = 0; i <= ctrlText.length; i++) {
                if (ctrlText != null && ctrlText.length > 0) {
                    if (ctrlText[i]["ScreenName"].length > 0) {
                        return ctrlText;
                    }
                }

            }
        }
        catch (e) { return items; }
    }

}
@Pipe({
    name: 'fieldbasedfilter'
})
@Injectable()
export class FieldBasedFilterPipe implements PipeTransform {
    transform(items: any[], colName1: string, colName2: string, colValue: string): any {
        try {
            let ctrlText = items.filter(item => item[colName1] != null && item[colName2] === colValue);
            return ctrlText;
        }
        catch (e) { return items; }
    }

}

@Pipe({
    name: 'contentstatus'
})
@Injectable()
export class ContentStatusPipe implements PipeTransform {
    ctrlText: any;
    transform(items: any, ctrlName: string): any {
        
        try {
            this.ctrlText = items.filter(item => item["ControlName"] === ctrlName)[0]['IsEnabled'];

            return (this.ctrlText == 1 || this.ctrlText == null) ? true : false;
        }
        catch (exception) {
            return 'error occured check filter.pipe.ts';
        }
    }
}

@Pipe({
    name: 'TxtLanguageContent'
})
@Injectable()
export class TxtLanguageContentPipe implements PipeTransform {
    ctrlText: any;
    transform(items: any, ctrlName: string): any {

        try {
            this.ctrlText = items.filter(item => item["ControlName"] === ctrlName)[0]['IsTxtLanEnabled'];

            return (this.ctrlText == 1 || this.ctrlText == null) ? true : false;
        }
        catch (exception) {
            return 'error occured check filter.pipe.ts';
        }
    }
}

@Pipe({
    name: 'contentfilter'
})
@Injectable()
export class ContentFilterPipe implements PipeTransform {
    
    storageService = new SessionStorageService();
    ctrlText: any;
    welcomeAgency: any;
    formType:any;

    constructor(private cspFormsService: cspFormsService){
        debugger;
        this.cspFormsService.currentData.subscribe(data => {
            let value : any;
            let url = window.location.href;
            let parts = url.split('/')
            value = parts[parts.length - 1]
            if(data == 'OR' || data == 'OP' ||value =="Openrecordrequest"){
                this.formType = 'Open Records Request Form'
            }
            if(data == 'SN'){
                this.formType = 'Special Needs Registry Form'
            } // Update the component when new data is received
          });
    }
	
    transform(items: any, ctrlName: string, welcomeAgency?: string, refNo?: string, errorMsg?: string): any {
    
        try {
            let lang = (this.storageService.getLang() ? this.storageService.getLang() : English);
            this.ctrlText = items.filter(item => item["ControlName"] === ctrlName && item["LanguageType"] === lang);

            if (this.ctrlText.length == 0) {
                this.ctrlText = items.filter(item => item["ControlName"] === ctrlName && item["LanguageType"] === English);
            }

            if (welcomeAgency)
                this.welcomeAgency = items.filter(item => item["ControlName"] === welcomeAgency && item["LanguageType"] === lang);
            if (welcomeAgency && this.welcomeAgency.length == 0) {
                this.welcomeAgency = items.filter(item => item["ControlName"] === welcomeAgency && item["LanguageType"] === English);
            }

            let paraTag = /<\/?p[^>]*>/g;
            let brkTag = /<br\s*\/?>/gi;
            let agencyCustomText: string;
            let agencyDefaultText: string;

            if (this.welcomeAgency && this.welcomeAgency.length > 0 && this.welcomeAgency[0]['CustomText']) {
                agencyCustomText = this.SetInitCap(this.welcomeAgency[0]['CustomText'].replace(paraTag, "").replace(brkTag, ""));
            }
            if (this.welcomeAgency && this.welcomeAgency.length > 0 && this.welcomeAgency[0]['DefaultText']) {
                agencyDefaultText = this.SetInitCap(this.welcomeAgency[0]['DefaultText'].replace(paraTag, "").replace(brkTag, ""));
            }

            if (this.ctrlText.length > 0) {
                if (this.ctrlText[0]['CustomText']) {
                    let CustomText = '';
                    CustomText =  this.GetContentResult(this.ctrlText[0]['CustomText'], agencyCustomText, agencyDefaultText);
                    if (ctrlName == 'PDFForm_SuccessMessage') {
                        CustomText =   CustomText.replace('[RefNo]', refNo);
                        CustomText =CustomText.replace('[FormType]',this.formType );
                        // sessionStorage.remove('FormType')
                    }
                    if (ctrlName == 'PDFForm_FailMessage') {
                        CustomText = CustomText.replace('[isError]', errorMsg);
                    }
                    return CustomText;
                   
                }
                else if (this.ctrlText[0]['DefaultText']) {
                    let DefaultText = '';
                    DefaultText = this.GetContentResult(this.ctrlText[0]['DefaultText'], agencyCustomText, agencyDefaultText);
                    if (ctrlName == 'PDFForm_SuccessMessage') {
                        DefaultText = DefaultText.replace('[RefNo]', refNo);
                    }
                    if (ctrlName == 'PDFForm_FailMessage') {
                        DefaultText = DefaultText.replace('[isError]', errorMsg);
                    }
                    return DefaultText;
                }
                else
                    return "";
            }
            else {
                return "";
            }

        }
        catch (e) {
            return "";
        }
    }

    //Setting Init Cap to given Texts(EG: some text => Some Text)
    SetInitCap(htmlString: any): string {

        let retString: string = "";

        //Checks weather the string has Html or not
        var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);

        if (isHTML(htmlString)) {
            var parser = new DOMParser();
            //Convert String to Xml Document using DomParser
            var element = parser.parseFromString(htmlString, "text/xml");

            if (element.childNodes[0].textContent.trim().split(' ').length > 1) {
                //Applying InitCap to Xml TexContent
                var setInitCap = element.childNodes[0].textContent.trim().split(' ').map(w => w[0].toUpperCase() + w.slice(1)).join(' ');

                //Replacing TextContent value
                element.childNodes[0].textContent = element.childNodes[0].textContent.replace(element.childNodes[0].textContent, setInitCap);

                //Return xml element as string
                retString = (new XMLSerializer()).serializeToString(element.childNodes[0]);
            }
        }
        else {
            retString = (htmlString.trim()) ? htmlString.trim().split(' ').map(w => w[0].toUpperCase() + w.slice(1)).join(' ') : "";
        }
        return retString;
    }

    GetContentResult(inputContent: string, agencyCustomText: string, agencyDefaultText: string) {
        let re = /\[CSAgency]/gi;
        //let repParaTag = /<[p>]+>/gm;

        let dptAddress1 = /\[dptAddress1]/gi;
        let dptAddress2 = /\[dptAddress2]/gi;
        let dptCity = /\[dptCity]/gi;
        let dptState = /\[dptState]/gi;
        let dptZipCode = /\[dptZipCode]/gi;
        let dptPhoneNumber = /\[dptPhoneNumber]/gi;
        let dptPhoneExtension = /\[dptPhoneExtension]/gi;
        let dptFaxNumber = /\[dptFaxNumber]/gi;
        let dptFaxExtension = /\[dptFaxExtension]/gi;
        let dptEmailID = /\[dptEmail]/gi;

        if (agencyCustomText || agencyDefaultText)
            inputContent = inputContent.replace(re, agencyCustomText ? agencyCustomText : agencyDefaultText);
        else
            //inputContent = inputContent.replace(re, window.location.hostname.replace(".prophoenix.com", "").replace(".com", ""));
            inputContent = inputContent.replace(re, this.storageService.getJurisName());

        return inputContent.replace(dptAddress1, this.storageService.getJurisAddress1() ? this.storageService.getJurisAddress1() : '')
            .replace(dptAddress2, this.storageService.getJurisAddress2() ? this.storageService.getJurisAddress2() : '')
            .replace(dptCity, this.storageService.getJurisCity() ? this.storageService.getJurisCity() : '')
            .replace(dptState, this.storageService.getJurisStateName() ? this.storageService.getJurisStateName() : '')
            .replace(dptZipCode, this.storageService.getJurisZip() ? this.storageService.getJurisZip() : '')
            .replace(dptPhoneNumber, this.storageService.getJurisPhoneNumber() ? this.formatPhoneNumber(this.storageService.getJurisPhoneNumber()) : '')
            .replace(dptPhoneExtension, this.storageService.getJurisPhoneExtension() ? this.storageService.getJurisPhoneExtension() : '')
            .replace(dptFaxNumber, this.storageService.getJurisFaxNumber() ? this.formatPhoneNumber(this.storageService.getJurisFaxNumber()) : '')
            .replace(dptFaxExtension, this.storageService.getJurisFaxExtension() ? this.storageService.getJurisFaxExtension() : '')
            .replace(dptEmailID, this.storageService.getJurisEmailID() ? this.storageService.getJurisEmailID() : '')
            .replace(',,', ',').replace(', ,', ',');
    }

    formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/pipes/filter.pipe.ts